import { render } from "./common.vue?vue&type=template&id=4b92c9c4&ts=true"
import script from "./common.vue?vue&type=script&lang=ts"
export * from "./common.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Project\\mc-cloud-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__